import type { ReactNode } from 'react';

export type PopupViewProps = {
  show?: boolean;
  onClose?: () => void | Promise<void>;
  children?: ReactNode;
};

export function PopupView({ show = false, onClose, children }: PopupViewProps) {
  if (!show) {
    return null;
  }

  return (
    <div
      className="popup-content bg-white border border-dark rounded-3 p-2 shadow position-absolute"
      style={{ minWidth: '300px' }}
    >
      <button
        type="button"
        className="btn-close position-absolute top-0 end-0 mt-1 me-1"
        aria-label="Close"
        onClick={() => void onClose?.()}
      ></button>

      {children}
    </div>
  );
}
